module.exports = __webpack_public_path__ + "static/media/wrl-ozarks-logo@2x.cfd975e1.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-ozarks-logo@2x.png
// module id = 1219
// module chunks = 0